
export default function TimeTable() {
  const today = new Date().toLocaleString("en-us", { weekday: "long" });

  const schedule = [
    {
      day: "Monday",
      slots: ["DS", "OS", "DBMS"],
    },
    {
      day: "Tuesday",
      slots: ["DBMS", "DS", "OS"],
    },
    {
      day: "Wednesday",
      slots: ["OS", "DBMS", "DS"],
    },
    {
      day: "Thursday",
      slots: ["DS", "DBMS", "OS"],
    },
    {
      day: "Friday",
      slots: ["OS", "DS", "DBMS"],
    },
  ];

  return (
    <div className="timetable-page">

      {/* HEADER */}
      <div className="timetable-header glass">
        <div>
          <h2>📅 Weekly Time Table</h2>
          <p>Your academic schedule for the week</p>
        </div>

        <span className="today-chip">
          Today: {today}
        </span>
      </div>

      {/* TIME TABLE GRID */}
      <div className="timetable-grid">
        {schedule.map((item, idx) => (
          <div
            key={idx}
            className={`day-card ${
              item.day === today ? "active-day" : ""
            }`}
          >
            <h3>{item.day}</h3>

            <div className="slot">
              <span>9 – 10</span>
              <strong>{item.slots[0]}</strong>
            </div>

            <div className="slot">
              <span>10 – 11</span>
              <strong>{item.slots[1]}</strong>
            </div>

            <div className="slot">
              <span>11 – 12</span>
              <strong>{item.slots[2]}</strong>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
